import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { supabase } from "./supabase";

export default function Navbar() {
  const [user, setUser] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setUser(session?.user ?? null);
      if (session?.user) checkAdmin(session.user.id);
    });
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setUser(session?.user ?? null);
      if (session?.user) {
        checkAdmin(session.user.id);
      } else {
        setIsAdmin(false);
      }
    });
    return () => subscription.unsubscribe();
  }, []);

  const checkAdmin = async (userId) => {
    const { data } = await supabase.from("admins").select("*").eq("user_id", userId);
    setIsAdmin(!!(data && data.length > 0));
  };

  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [menuOpen]);

  const handleLogout = async () => {
    await supabase.auth.signOut();
    window.location.href = "/";
  };

  const desktopLinks = [
    { name: "About", path: "/about" },
    { name: "How It Works", path: "/howitworks" },
    { name: "Forge Vault", path: "/forge-vault" },
    { name: "Projects", path: "/projects" },
    { name: "Community", path: "/community" },
    { name: "Suppliers", path: "/suppliers" },
    { name: "Testimony", path: "/testimony" },
  ];

  const mobileLinks = [
    { name: "About", path: "/about", icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg> },
    { name: "How It Works", path: "/howitworks", icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 8v4l3 3"/></svg> },
    { name: "Forge Vault", path: "/forge-vault", icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0110 0v4"/></svg> },
    { name: "Projects", path: "/projects", icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></svg> },
    { name: "Community", path: "/community", icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/></svg> },
    { name: "Suppliers", path: "/suppliers", icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l2-7h14l2 7"/><path d="M3 9v11a1 1 0 001 1h16a1 1 0 001-1V9"/><path d="M9 21V14h6v7"/></svg> },
    { name: "Testimony", path: "/testimony", icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/></svg> },
    { name: "FAQ", path: "/faq", icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 015.83 1c0 2-3 3-3 3M12 17h.01"/></svg> },
    { name: "The Forge", path: "/the-forge", icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2C8 6 6 10 8 14c-2-1-3-3-3-5C3 13 2 17 5 20c1.5 1.5 3.5 2 6 2 5 0 8-3 8-7 0-2-1-4-2.5-5.5C16 11 15 13 13 14c1-3 0-7-1-12z"/></svg> },
  ];

  const adminIcon = <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><polyline points="9 12 11 14 15 10"/></svg>;

  const firstName = user?.user_metadata?.first_name || "";

  return (
    <>
      <style>{`
        @media (max-width: 768px) {
          .desktop-nav { display: none !important; }
          .desktop-auth { display: none !important; }
          .hamburger { display: flex !important; }
          .forge-nav { padding: 0 20px !important; }
        }
        .mob-link {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 13px 14px;
          border-radius: 12px;
          text-decoration: none;
          transition: all 0.15s;
        }
        .mob-link.active {
          background: #1B3A6B;
        }
        .mob-link-icon {
          width: 30px;
          height: 30px;
          border-radius: 8px;
          background: rgba(27,58,107,0.1);
          display: flex;
          align-items: center;
          justify-content: center;
          color: #1B3A6B;
          flex-shrink: 0;
        }
        .mob-link.active .mob-link-icon {
          background: rgba(255,255,255,0.15);
          color: #fff;
        }
        .mob-link-name {
          font-size: 15px;
          font-weight: 700;
          color: #1A1A2E;
          font-family: var(--font-body);
        }
        .mob-link.active .mob-link-name {
          color: #fff;
        }
      `}</style>

      <nav className="forge-nav" style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "0 48px",
        height: 72,
        background: "#FFFFFF",
        borderBottom: "1px solid #EDE8DF",
        position: "sticky",
        top: 0,
        zIndex: 200,
      }}>

        {/* Logo */}
        <Link to="/" style={{ display: "flex", alignItems: "center", gap: 12, textDecoration: "none" }}>
           <img src="/logo192.png" alt="Forge SA" style={{ width: 40, height: 40, objectFit: "contain" }} />
          <div style={{ display: "flex", flexDirection: "column", gap: 1 }}>
            <div style={{ fontFamily: "var(--font-body)", fontWeight: 800, fontSize: 20, color: "#1A1A2E", letterSpacing: "0.06em", lineHeight: 1 }}>
              FORGE <span style={{ color: "#5B9BD5" }}>SA</span>
            </div>
            <div style={{ fontFamily: "var(--font-body)", fontSize: 9, color: "#888888", letterSpacing: "0.18em", textTransform: "uppercase" }}>
              Built by us. For us.
            </div>
          </div>
        </Link>

        {/* Desktop Nav */}
        <div style={{ display: "flex", gap: 32, alignItems: "center" }} className="desktop-nav">
          {desktopLinks.map((item) => {
            const isActive = location.pathname === item.path;
            return (
              <Link key={item.name} to={item.path} style={{
                fontFamily: "var(--font-body)", fontSize: 11, fontWeight: 600,
                color: isActive ? "#1B3A6B" : "#4A4A6A", textDecoration: "none",
                letterSpacing: "0.14em", textTransform: "uppercase",
                borderBottom: isActive ? "2px solid #1B3A6B" : "2px solid transparent",
                paddingBottom: 4, transition: "all 0.2s",
              }}>
                {item.name}
              </Link>
            );
          })}
          {isAdmin && (
            <Link to="/admin" style={{
              fontFamily: "var(--font-body)", fontSize: 11, fontWeight: 700,
              color: location.pathname === "/admin" ? "#C9A84C" : "#8a6a1a",
              textDecoration: "none", letterSpacing: "0.14em", textTransform: "uppercase",
              display: "flex", alignItems: "center", gap: 5,
              borderBottom: location.pathname === "/admin" ? "2px solid #C9A84C" : "2px solid transparent",
              paddingBottom: 4, transition: "all 0.2s",
            }}>
              {adminIcon}
              Admin
            </Link>
          )}
        </div>

        {/* Desktop Auth */}
        <div className="desktop-auth">
          {user ? (
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <Link to="/dashboard" style={{ textDecoration: "none" }}>
                <div style={{ display: "flex", alignItems: "center", gap: 8, background: "#F5F0E8", border: "1px solid #EDE8DF", borderRadius: 99, padding: "8px 16px", cursor: "pointer" }}>
                  <div style={{ width: 26, height: 26, background: "#1B3A6B", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 11, fontWeight: 700, color: "#fff", fontFamily: "var(--font-body)" }}>
                    {firstName.charAt(0).toUpperCase()}
                  </div>
                  <span style={{ color: "#1B3A6B", fontSize: 13, fontWeight: 600, fontFamily: "var(--font-body)" }}>{firstName}</span>
                </div>
              </Link>
              <button onClick={handleLogout} style={{ display: "flex", alignItems: "center", gap: 6, background: "transparent", border: "1px solid #EDE8DF", borderRadius: 99, padding: "8px 18px", color: "#4A4A6A", fontWeight: 600, fontSize: 12, cursor: "pointer", fontFamily: "var(--font-body)" }}>
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4"/>
                  <polyline points="16 17 21 12 16 7"/>
                  <line x1="21" y1="12" x2="9" y2="12"/>
                </svg>
                Sign Out
              </button>
            </div>
          ) : (
            <Link to="/register" style={{ textDecoration: "none" }}>
              <button style={{ background: "#1B3A6B", border: "none", borderRadius: 99, padding: "12px 28px", color: "#fff", fontWeight: 700, fontSize: 14, cursor: "pointer", fontFamily: "var(--font-body)" }}>
                Join the Movement
              </button>
            </Link>
          )}
        </div>

        {/* Hamburger */}
        <button
          className="hamburger"
          onClick={() => setMenuOpen(!menuOpen)}
          style={{ display: "none", background: "transparent", border: "none", cursor: "pointer", padding: 8, alignItems: "center", justifyContent: "center" }}
        >
          {menuOpen ? (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#1A1A2E" strokeWidth="2.5" strokeLinecap="round">
              <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          ) : (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#1A1A2E" strokeWidth="2.5" strokeLinecap="round">
              <line x1="3" y1="6" x2="21" y2="6"/>
              <line x1="3" y1="12" x2="21" y2="12"/>
              <line x1="3" y1="18" x2="21" y2="18"/>
            </svg>
          )}
        </button>

      </nav>

      {/* Mobile Menu */}
      {menuOpen && (
        <div style={{
          position: "fixed",
          top: 72,
          left: 0,
          right: 0,
          bottom: 0,
          background: "#fff",
          zIndex: 199,
          overflowY: "auto",
          padding: "12px 16px 32px",
        }}>

          {/* Watermark */}
          <div style={{
            position: "absolute",
            top: "35%",
            left: "50%",
            transform: "translate(-50%, -50%) rotate(-25deg)",
            fontSize: 52,
            fontWeight: 900,
            color: "#C9A84C",
            opacity: 0.04,
            whiteSpace: "nowrap",
            letterSpacing: 8,
            pointerEvents: "none",
            userSelect: "none",
            fontFamily: "var(--font-body)",
          }}>
            FORGE SA
          </div>

          {/* Vertical Nav Links */}
          <div style={{ display: "flex", flexDirection: "column", gap: 4, marginBottom: 20 }}>
            {mobileLinks.map((item) => {
              const isActive = location.pathname === item.path;
              return (
                <Link
                  key={item.name}
                  to={item.path}
                  className={`mob-link${isActive ? " active" : ""}`}
                >
                  <div className="mob-link-icon">{item.icon}</div>
                  <div className="mob-link-name">{item.name}</div>
                </Link>
              );
            })}
            {isAdmin && (
              <Link
                to="/admin"
                className={`mob-link${location.pathname === "/admin" ? " active" : ""}`}
                style={{ background: location.pathname === "/admin" ? "#1B3A6B" : "rgba(201,168,76,0.1)" }}
              >
                <div className="mob-link-icon" style={{
                  background: location.pathname === "/admin" ? "rgba(255,255,255,0.15)" : "rgba(201,168,76,0.2)",
                  color: location.pathname === "/admin" ? "#fff" : "#8a6a1a",
                }}>
                  {adminIcon}
                </div>
                <div className="mob-link-name" style={{ color: location.pathname === "/admin" ? "#fff" : "#8a6a1a" }}>
                  Admin
                </div>
              </Link>
            )}
          </div>

          {/* Divider */}
          <div style={{ height: 1, background: "#EDE8DF", marginBottom: 20 }} />

          {/* Auth */}
          {user ? (
            <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
              <Link to="/dashboard" style={{ textDecoration: "none" }}>
                <div style={{ display: "flex", alignItems: "center", gap: 14, background: "#F5F0E8", border: "1px solid #EDE8DF", borderRadius: 16, padding: "16px 20px" }}>
                  <div style={{ width: 40, height: 40, background: "#1B3A6B", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 15, fontWeight: 700, color: "#fff", flexShrink: 0 }}>
                    {firstName.charAt(0).toUpperCase()}
                  </div>
                  <div>
                    <div style={{ fontSize: 15, fontWeight: 700, color: "#1B3A6B", fontFamily: "var(--font-body)" }}>{firstName}</div>
                    <div style={{ fontSize: 12, color: "#888", fontFamily: "var(--font-body)" }}>View Dashboard</div>
                  </div>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#888" strokeWidth="2" strokeLinecap="round" style={{ marginLeft: "auto" }}>
                    <polyline points="9 18 15 12 9 6"/>
                  </svg>
                </div>
              </Link>
              <button onClick={handleLogout} style={{ width: "100%", background: "transparent", border: "1.5px solid #EDE8DF", borderRadius: 99, padding: "14px", color: "#4A4A6A", fontWeight: 600, fontSize: 14, cursor: "pointer", fontFamily: "var(--font-body)" }}>
                Sign Out
              </button>
            </div>
          ) : (
            <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
              <Link to="/register" style={{ textDecoration: "none" }}>
                <button style={{ width: "100%", background: "#1B3A6B", border: "none", borderRadius: 99, padding: "16px", color: "#fff", fontWeight: 700, fontSize: 15, cursor: "pointer", fontFamily: "var(--font-body)" }}>
                  Join the Movement
                </button>
              </Link>
              <Link to="/login" style={{ textDecoration: "none" }}>
                <button style={{ width: "100%", background: "transparent", border: "1.5px solid #EDE8DF", borderRadius: 99, padding: "14px", color: "#4A4A6A", fontWeight: 600, fontSize: 14, cursor: "pointer", fontFamily: "var(--font-body)" }}>
                  Sign In
                </button>
              </Link>
            </div>
          )}

          {/* Footer branding */}
          <div style={{ textAlign: "center", marginTop: 28 }}>
            <div style={{ fontSize: 13, fontWeight: 800, color: "#1A1A2E", letterSpacing: "0.06em", fontFamily: "var(--font-body)" }}>
              FORGE <span style={{ color: "#5B9BD5" }}>SA</span>
            </div>
            <div style={{ fontSize: 10, color: "#888", letterSpacing: "0.14em", textTransform: "uppercase", marginTop: 4, fontFamily: "var(--font-body)" }}>
              Built by us. For us.
            </div>
          </div>

        </div>
      )}
    </>
  );
}